import UpdatePost from "./UpdatePost"

export default UpdatePost